<template>
  <PopupPanel
    :show="show"
    position="bottom"
    radius="5px"
    height="80%"
    type="unit"
    :title="title"
    @panel="panelClick"
  >
    <div class="panel-unit-list">
      <ul v-for="(model, index) in units" :key="index">
        <tree-menu :model="model" icon="hotel-o" @item="panelClick"></tree-menu>
      </ul>
    </div>
  </PopupPanel>
</template>

<script>
import PopupPanel from "./PopupPanel";
import TreeMenu from "./TreeMenu";

export default {
  name: "UnitPanel",
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "请选择单位" },
    units: { type: Array, required: true },
  },
  components: {
    TreeMenu,
    PopupPanel,
  },
  methods: {
    panelClick(data) {
      console.info("data", data);
      this.$emit("panel", "unit", data);
    },
  },
};
</script>
<style lang="less" scoped>
.panel-unit-list {
  display: flex;
  flex-direction: column;
  height: ~"calc(100% - 40px)";
  overflow-y: scroll;
}
</style>
